export default __webpack_public_path__ + "static/media/fg-model-01.cdc32d4c.glb";